import {
  LINK_NAME_BENEFITS,
  LINK_NAME_QUALIFICATIONS,
  LINK_NAME_RESPONSIBILITIES,
  OBJECT_INTERACTION_BENEFITS,
  OBJECT_INTERACTION_QUALIFICATIONS,
  OBJECT_INTERACTION_RESPONSIBILITIES,
  EVENT_NAME_TEXT_INPUT_INTERACTION,
} from 'src/app/analytics';
import type { Tealium } from 'src/types/appState';
import type { TealiumEventData, TrackingEvent } from 'src/types/trackingData';

const EVENT_NAME_JOB_DETAILS_ADDED = 'ecaja-job-details-added';
const EVENT_NAME_JOB_DETAILS_REMOVED = 'ecaja-job-details-removed';

type EventData = TrackingEvent | TealiumEventData;

export type TrackingFunction = (tealium: Tealium, eventData: EventData) => void;

const getTrackingEvent = (
  linkName: string,
  eventName:
    | typeof EVENT_NAME_JOB_DETAILS_ADDED
    | typeof EVENT_NAME_JOB_DETAILS_REMOVED,
  objectInteration: string,
) => ({
  linkName,
  eventName: [EVENT_NAME_TEXT_INPUT_INTERACTION, eventName, linkName],
  objectInteraction: objectInteration,
});

export const responsiblitiesOnBlurOldTrackingEvent: TealiumEventData =
  getTrackingEvent(
    LINK_NAME_RESPONSIBILITIES,
    EVENT_NAME_JOB_DETAILS_ADDED,
    OBJECT_INTERACTION_RESPONSIBILITIES,
  );

export const qualificiationsOnBlurOldTrackingEvent: TealiumEventData =
  getTrackingEvent(
    LINK_NAME_QUALIFICATIONS,
    EVENT_NAME_JOB_DETAILS_ADDED,
    OBJECT_INTERACTION_QUALIFICATIONS,
  );

export const benefitsOnBlurOldTrackingEvent: TealiumEventData =
  getTrackingEvent(
    LINK_NAME_BENEFITS,
    EVENT_NAME_JOB_DETAILS_ADDED,
    OBJECT_INTERACTION_BENEFITS,
  );

export const responsibilitiesOnRemovedOldTrackingEvent: TealiumEventData =
  getTrackingEvent(
    LINK_NAME_RESPONSIBILITIES,
    EVENT_NAME_JOB_DETAILS_REMOVED,
    OBJECT_INTERACTION_RESPONSIBILITIES,
  );

export const qualificationsOnRemovedOldTrackingEvent: TealiumEventData =
  getTrackingEvent(
    LINK_NAME_QUALIFICATIONS,
    EVENT_NAME_JOB_DETAILS_REMOVED,
    OBJECT_INTERACTION_QUALIFICATIONS,
  );

export const benefitsOnRemovedOldTrackingEvent: TealiumEventData =
  getTrackingEvent(
    LINK_NAME_BENEFITS,
    EVENT_NAME_JOB_DETAILS_REMOVED,
    OBJECT_INTERACTION_BENEFITS,
  );
